/**
 * @param {number} alpha
 * @returns {number[]}
 */

export function rad2deg(alpha) {
    return alpha * 180 / Math.PI;
}

export function cart2sphere(x, y, z, posePitchCos=0, posePitchSin=0, poseRollCos=0, poseRollSin=0) {
    if ((posePitchCos && posePitchSin) || (poseRollCos && poseRollSin)) {
        posePitchSin = -posePitchSin;
        posePitchCos = -posePitchCos;
        poseRollCos = -poseRollCos;
        poseRollSin = -poseRollSin;

        let ox = px * poseRollCos + pz * poseRollSin;
        let oy = py * posePitchCos + posePitchSin * (px * poseRollSin - pz * poseRollCos);
        z = py * posePitchSin - posePitchCos * (px * poseRollSin - pz * poseRollCos);
        x = ox; y = oy;
    }

    let r = Math.sqrt(x * x + y * y + z * z);
    let pitch = Math.asin(Math.max(Math.min(z / r, 1), -1));
    let yaw = Math.atan2(x, y);

    return [yaw, pitch];
}

export function equi2sphere(x, y) {
    let xp = x / this._buffer.width;
    let yp = y / this._buffer.height;

    let yaw = xp * 360 - 180;
    let pitch = (yp - 0.5) * -180;

    return [deg2rad(yaw), deg2rad(pitch)];
}

export function get2DLineAngle([x1, y1], [x2, y2]) {
    return Math.atan2(y2 - y1, x2 - x1);
}

export function deg2rad(alpha) {
    return alpha * Math.PI / 180;
}

export function sphere2equi(yaw, pitch, width, height, posePitchCos=0, posePitchSin=0, poseRollCos=0, poseRollSin=0, poseRoll, posePitch){
    [yaw, pitch] = sphereCoordsCorrection(yaw, pitch, {posePitchCos, posePitchSin, poseRollCos, poseRollSin,  poseRoll, posePitch})

    let yp = rad2deg(pitch) / -180 + 0.5;
    let xp = (rad2deg(yaw) + 180) / 360;

    return [xp * width, yp * height];
}

function sphereCoordsCorrection(yaw, pitch, {posePitchCos, posePitchSin, poseRollCos, poseRollSin, poseRoll, posePitch}) {
    let [x, y, z] = spher2Cart(yaw, pitch, {posePitchCos, posePitchSin, poseRollCos, poseRollSin, poseRoll, posePitch});

    let r = Math.sqrt(x*x + y*y + z*z);

    pitch = Math.asin(Math.max(Math.min(z/r, 1), -1));
    yaw = Math.atan2(x, y);

    return [yaw, pitch];
}

export function sphere22d(yaw, pitch) {
    let dist = pitch < 0 ? Math.tan(pitch + Math.PI / 2) : Math.tan(Math.PI / 2 - pitch) ;
    let angle = -yaw + Math.PI / 2;

    return [dist * Math.cos(angle), dist * Math.sin(angle)];
}

export function spher2Cart(yaw, pitch,  {poseRoll, posePitch}){
    let x = Math.cos(pitch)*Math.sin(yaw),
        y = Math.cos(pitch)*Math.cos(yaw),
        z = Math.sin(pitch);

    if (poseRoll || posePitch) {
        let ox = x * Math.cos(poseRoll) + Math.sin(poseRoll) * ( y * Math.sin(posePitch) + z * Math.cos(posePitch) );
        let oy = y * Math.cos(posePitch) - z * Math.sin(posePitch);
        z = -x * Math.sin(poseRoll) + Math.cos(poseRoll) * ( y * Math.sin(posePitch) + z * Math.cos(posePitch) );
        x = ox; y=oy;
    }

    return [x, y, z];
}

export function spher2CartCoord(yaw, pitch, {poseRoll, posePitch}){
    let x = Math.cos(pitch)*Math.sin(yaw),
        y = Math.cos(pitch)*Math.cos(yaw),
        z = Math.sin(pitch);

    if (poseRoll || posePitch) {
        let ox = x * Math.cos(poseRoll) + Math.sin(poseRoll) * ( y * Math.sin(posePitch) + z * Math.cos(posePitch) );
        let oy = y * Math.cos(posePitch) - z * Math.sin(posePitch);
        z = -x * Math.sin(poseRoll) + Math.cos(poseRoll) * ( y * Math.sin(posePitch) + z * Math.cos(posePitch) );
        x = ox; y=oy;
    }

    return [x,y,z];
}
/**
 * Normalize yaw value within the range from -Math.PI to Math.PI
 * @param {number} yaw
 * @returns {number}
 */
export function normalizeYaw(yaw) {
    let PI2 = Math.PI * 2;
    return ((yaw + PI2 + Math.PI) % PI2) - Math.PI;
}

export function inside(x, y, points) {
    let inside = false;

    for (var i = 0, j = points.length - 1; i < points.length; j = i++) {
        let xi = points[i].x, yi = points[i].y;
        let xj = points[j].x, yj = points[j].y;

        let intersect = ((yi > y) != (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);

        if (intersect) {
            inside = !inside;
        }
    }

    return inside;
}

/**
 * Rotate each vertex of vertices Map
 * @param {Object.<string, [number, number]>} points
 * @param {number} angle
 */
export function rotate2DPoints(points, angle) {
    let res = {};
    for (let i in points) {
        if (points.hasOwnProperty(i))
            res[i] = rotate2DPoint(points[i], angle);
    }
    return res;
}

/**
 * Rotate 2d point related to (0,0)
 * @param {number} x
 * @param {number} y
 * @param {number} angle
 * @returns {number[]}
 */

export function  rotate2DPoint([x, y], angle) {
    let dist = Math.sqrt(x * x + y * y);
    angle += Math.atan2(y, x).toFixed(13)*1;
    return [Math.cos(angle) * dist, Math.sin(angle) * dist];
}

export function sortPoints(points){
    points.sort((a,b)=>a.y - b.y);
    const cy = (points[0].y + points[points.length -1].y) / 2;
    points.sort((a,b)=>b.x - a.x);
    const cx = (points[0].x + points[points.length -1].x) / 2;
    const center = {x:cx,y:cy};
    let startAng;
    points.forEach(point => {
        var ang = Math.atan2(point.y - center.y,point.x - center.x);
        if(!startAng){ startAng = ang }
        else {
            if(ang < startAng){
                ang += Math.PI * 2;
            }
        }
        point.angle = ang;
    });
    points.sort((a,b)=> a.angle - b.angle);

    return points;
}

export function clockwiseDirections(points) {
    let subX = Math.min(0, Math.min.apply(null, points.map((p) => p.x)));
    let subY = Math.min(0, Math.min.apply(null, points.map((p) => p.x)));
    let newPoints = points.map((p) => {
        return {
            x: p.x - subX,
            y: p.y - subY
        }
    });

    let sum = 0;

    for ( let i = 0; i < newPoints.length; i++ ) {
        let c1 = newPoints[i],c2;
        if (i === newPoints.length - 1) {
            c2 = newPoints[0]
        } else {
            c2 = newPoints[i+1];
        }
        sum += (c2.x - c1.x) * (c2.y + c1.y);
    }

    return (sum >= 0);
}

/**
 * Calculate x and z coords to be greater then 1 with saving vector [x,z] angle
 * @param x {number}
 * @param y {number}
 * @param z {number}
 * @returns {{x: *, y: *, z: *}} - normalized vector
 */
export function normalizeCameraPosition({x, y, z}) {
    const expX = !x ? 0 : Math.floor(Math.log(Math.abs(x)) * Math.LOG10E);
    const expZ = !z ? 0 : Math.floor(Math.log(Math.abs(z)) * Math.LOG10E);
    let exp;

    if ((expX >= 0 && expZ >= 0) || Math.abs(expX - expZ) > 1) return {x, y, z};

    exp = expX < 0 && expZ < 0
        ? Math.abs(expX) > Math.abs(expZ)
            ? Math.abs(expX)
            : Math.abs(expZ)
        : expX < 0
            ? Math.abs(expX)
            : Math.abs(expZ);

    return {x: expX >=0 ? x : x * Math.pow(10, exp), y, z: expZ >=0 ? z : z * Math.pow(10, exp)}
}
